window.isSmartDevice=function ($window){
	// Adapted from http://www.detectmobilebrowsers.com
	var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
	// Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
	return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
}


// WEBPACK FOOTER //
// ./src/app/common/helpers/custom.js